<template>
  <v-app class="bg-black">
    <div v-if="$env.VITE_NODE_ENV != 'production'">
      <div class="text-center text-uppercase bg-brown position-fixed py-3 px-3 z-index-700" style="bottom: 52px;">
        {{$env.VITE_APP_VERSION}}
      </div>
    </div>
    <default-bar />
    <snack-bar /> 
    <default-view />
    <default-footer />
    <v-fab :href="`https://wa.me/+393286344651?text=${encodeURIComponent(whatsappWelcomeMessage)}`" :app="true" size="x-large" :location="`right bottom`" color="#25D366" icon="mdi-whatsapp" class="wh-btn"></v-fab> 
    <br>
    <br>
    <floating-contacts />
  </v-app>
</template>

<script setup>
  import { computed } from 'vue'
  import { useHead } from '@unhead/vue'
  import { useRoute } from 'vue-router'
  import DefaultFooter from './AppFooter.vue'
  import DefaultBar from './AppBar.vue'
  import SnackBar from '@/components/common/SnackBar.vue'
  import floatingContacts from './floatingContacts.vue'
  import DefaultView from './View.vue'

  const locale = localStorage.getItem('locale') || 'it'
  const route = useRoute()

  const gadSource = route.query.gad_source
  const utmSource = route.query.utm_source
  const fromGoogle = gadSource && gadSource === '1'
  const fromMeta = utmSource && utmSource === 'meta'
  const fromNewsletter = utmSource && utmSource === 'newsletter'

  const whatsappWelcomeMessage = computed(() => {
    const messages = {
      it: {
        fromGoogleMessage: 'Ciao, vorrei maggiori informazioni per un noleggio.',
        fromMetaMessage: 'Piacere, vorrei maggiori informazioni per un noleggio.',
        fromNewsletterMessage: 'Buongiorno, vorrei maggiori informazioni per un noleggio.',
        fromOrganicMessage: 'Salve, vorrei maggiori informazioni per un noleggio.'
      },
      en: {
        fromGoogleMessage: 'Hello! I\'m interested in getting some info about renting a car.',
        fromMetaMessage: 'Hey there! I\'m interested in getting some info about renting a car.',
        fromNewsletterMessage: 'Greetings! I\'m interested in getting some info about renting a car.',
        fromOrganicMessage: 'Hi! I\'m interested in getting some info about renting a car.'
      }
    }

    if (fromGoogle) {
      return messages[locale].fromGoogleMessage
    } else if (fromMeta) {
      return messages[locale].fromMetaMessage
    } else if (fromNewsletter) {
      return messages[locale].fromNewsletterMessage
    } else {
      return messages[locale].fromOrganicMessage
    }
  })

  const jsonLdIt = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Primerent",
    "legalName": "Prime S.R.L.",
    "url": "https://www.primerentcar.com/it",
    "logo": "https://www.primerentcar.com/icons/logotipo.svg",
    "description": "Primerent è la società italiana leader nel noleggio a breve e medio termine di auto di lusso...",
    "vatID": "IT02002890560",
    "foundingDate": "2005",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Via Flaminia Vecchia 491",
      "addressLocality": "Roma",
      "postalCode": "00191",
      "addressCountry": "IT"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+39 06 3322 0167",
        "contactType": "customer service",
        "areaServed": ["IT","ES","CH","FR","EU"],
        "availableLanguage": ["Italian","English","Spanish","French"]
      }
    ],
    "sameAs": [
      "https://www.instagram.com/primerent_car",
      "https://www.facebook.com/primerentcar",
      "https://www.youtube.com/@primerentcar",
      "https://www.linkedin.com/company/primerent"
    ]
  }

  const jsonLdEn = {
    ...jsonLdIt,
    url: "https://www.primerentcar.com/en",
    description: "Primerent is Italy’s leading luxury and premium car‑rental company, delivering and collecting vehicles anywhere in Italy and Southern Europe with a 24/7 concierge service."
  }

  useHead({
    script: [
      {
        type: 'application/ld+json',
        children: JSON.stringify(locale === 'en' ? jsonLdEn : jsonLdIt)
      }
    ]
  })
</script>

<style>
.wh-btn .v-fab__container {
  right: 10px;
  bottom: 50px !important;
}
.wh-btn .v-icon {
  color: white !important;
}
</style>


